import {roundTo15MinIntervalStart} from '@hconnect/common/utils'
import {useTheme} from '@mui/material'
import moment, {Moment} from 'moment-timezone'
import React from 'react'

import {NOW_INDICATOR_REFRESH_INTERVAL_MS} from '../../constants'
import {useCurrentTime} from '../../hooks/useCurrentTime'

import {ChartDateIndicator} from './ChartDateIndicator'

type ChartNowIndicatorProps = {
  hoursDisplayed: number
  cellWidth: number
  shouldRoundCurrentTime: boolean
  timezoneId: string
  startOfChart: Moment
  endOfChart: Moment
  getNowLabel: (time: string) => string
}

export const ChartNowIndicator: React.FC<ChartNowIndicatorProps> = ({
  hoursDisplayed,
  cellWidth,
  shouldRoundCurrentTime,
  timezoneId,
  startOfChart,
  endOfChart,
  getNowLabel
}) => {
  const theme = useTheme()

  const currentTime = useCurrentTime({
    timezoneId,
    intervalMs: NOW_INDICATOR_REFRESH_INTERVAL_MS
  })
  const currentTimeAfterRounding =
    shouldRoundCurrentTime && currentTime ? roundTo15MinIntervalStart(currentTime) : currentTime

  return (
    <ChartDateIndicator
      startOfChart={startOfChart}
      endOfChart={endOfChart}
      label={getNowLabel(currentTimeAfterRounding?.format('HH:mm') ?? '')}
      hoursDisplayed={hoursDisplayed}
      cellWidth={cellWidth}
      time={currentTimeAfterRounding ?? moment()}
      backgroundColor={theme.palette.text.primary}
      color={theme.palette.background.paper}
    />
  )
}
